import { connect } from "react-redux";

import Help from "./Help";

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Help);
